import { useSelector } from 'react-redux';

import type { SchoolV1 } from 'types';

export const useSchoolV1 = () => {
  const school: SchoolV1 | null = useSelector(
    (state) => (state as any).schools.currentSchool,
  );

  const error = useSelector(
    (state) => (state as any).schools.currentSchoolError,
  );
  const isNotFound = error?.response?.status === 404;

  return { school, isNotFound, hasError: Boolean(error) };
};
